import * as API from '@/api/index'

export const multi_points_cal=(params)=>{
    return API.POST('/multi_points_cal',params, { notLoading: true })
}